import VanzatorStep from "./steps/VanzatorStep";
import CumparatorStep from "./steps/CumparatorStep";
import AutoStep from "./steps/AutoStep";
import PretStep from "./steps/PretStep";
import ConditiiStep from "./steps/ConditiiStep";
import PreviewStep from "./steps/PreviewStep";
import buildVanzareAutoPDF from "./buildPDF";

const vanzareAutoConfig = {
  buildPDF: buildVanzareAutoPDF,
  title: "Contract Vanzare-Cumparare Auto Model 2026 (PDF)",
  subtitle: "Completeaza datele si genereaza un contract de vanzare-cumparare auto conform Codului Civil.",
  step1Benefit: "Model complet cu stare tehnică și clauze de garanție",
  pdfFilename: "contract-vanzare-cumparare-auto.pdf",
  steps: [
    { id: "vanzator", label: "Vanzator", title: "Datele Vanzatorului", icon: "\uD83D\uDC64", component: VanzatorStep },
    { id: "cumparator", label: "Cumparator", title: "Datele Cumparatorului", icon: "\uD83D\uDC65", component: CumparatorStep },
    { id: "auto", label: "Auto", title: "Detalii Autovehicul", icon: "\uD83D\uDE97", component: AutoStep },
    { id: "pret", label: "Pret", title: "Pret si Plata", icon: "\uD83D\uDCB0", component: PretStep },
    { id: "conditii", label: "Conditii", title: "Conditii si Stare Tehnica", icon: "\uD83D\uDCCB", component: ConditiiStep },
    { id: "preview", label: "Preview", title: "Previzualizare Contract", icon: "\uD83D\uDCC4", component: PreviewStep },
  ],
  defaultData: {
    vanzatorPJ: false,
    vanzatorNume: "",
    vanzatorCNP: "",
    vanzatorCI: "",
    vanzatorAdresa: "",
    vanzatorFirma: "",
    vanzatorCUI: "",
    vanzatorRegCom: "",
    vanzatorSediu: "",
    vanzatorReprezentant: "",
    cumparatorPJ: false,
    cumparatorNume: "",
    cumparatorCNP: "",
    cumparatorCI: "",
    cumparatorAdresa: "",
    cumparatorFirma: "",
    cumparatorCUI: "",
    cumparatorRegCom: "",
    cumparatorSediu: "",
    cumparatorReprezentant: "",
    marca: "",
    model: "",
    anFabricatie: "",
    nrInmatriculare: "",
    serieSasiu: "",
    nrMotor: "",
    culoare: "",
    combustibil: "benzina",
    capacitateCilindrica: "",
    kmRulati: "",
    kmDeclaratie: "real",
    pretVanzare: "",
    valuta: "RON",
    cursValutar: "",
    modalitatePlata: "transfer bancar",
    sumaNumerar: "",
    dataVanzare: "",
    pretAchitatLaSemnare: true,
    stareTehnica: "buna",
    itpValid: true,
    rcaValid: true,
    liberSarcini: true,
    garantieActiva: false,
    garantieLuni: "3",
    garantieMotor: false,
    garantieCutie: false,
    garantieFranare: false,
    garantieAlte: false,
    garantieAlteText: "",
    martori: false,
  },
  validate: (stepId, data) => {
    const errors = {};

    if (stepId === "vanzator") {
      if (data.vanzatorPJ) {
        if (!data.vanzatorFirma.trim() || data.vanzatorFirma.trim().length < 2) {
          errors.vanzatorFirma = "Denumirea societatii este obligatorie (min. 2 caractere)";
        }
        if (!data.vanzatorCUI.trim()) {
          errors.vanzatorCUI = "CUI-ul este obligatoriu";
        } else if (!/^(RO)?\d{2,10}$/i.test(data.vanzatorCUI.trim())) {
          errors.vanzatorCUI = "Format invalid (ex: RO12345678 sau 12345678)";
        }
        if (!data.vanzatorSediu.trim()) errors.vanzatorSediu = "Sediul social este obligatoriu";
        if (!data.vanzatorReprezentant.trim()) {
          errors.vanzatorReprezentant = "Reprezentantul legal este obligatoriu";
        } else if (data.vanzatorReprezentant.trim().split(/\s+/).length < 2) {
          errors.vanzatorReprezentant = "Introduceti numele complet (nume si prenume)";
        }
      } else {
        if (!data.vanzatorNume.trim()) {
          errors.vanzatorNume = "Numele este obligatoriu";
        } else if (data.vanzatorNume.trim().split(/\s+/).length < 2) {
          errors.vanzatorNume = "Introduceti numele complet (nume si prenume)";
        }
        if (data.vanzatorCNP.trim() && !/^\d{13}$/.test(data.vanzatorCNP.trim())) {
          errors.vanzatorCNP = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data.vanzatorCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.vanzatorCI.trim())) {
          errors.vanzatorCI = "Format invalid (ex: RD 123456 sau RD 1234567)";
        }
        if (!data.vanzatorAdresa.trim()) errors.vanzatorAdresa = "Adresa este obligatorie";
      }
    }

    if (stepId === "cumparator") {
      if (data.cumparatorPJ) {
        if (!data.cumparatorFirma.trim() || data.cumparatorFirma.trim().length < 2) {
          errors.cumparatorFirma = "Denumirea societatii este obligatorie (min. 2 caractere)";
        }
        if (!data.cumparatorCUI.trim()) {
          errors.cumparatorCUI = "CUI-ul este obligatoriu";
        } else if (!/^(RO)?\d{2,10}$/i.test(data.cumparatorCUI.trim())) {
          errors.cumparatorCUI = "Format invalid (ex: RO12345678 sau 12345678)";
        }
        if (!data.cumparatorSediu.trim()) errors.cumparatorSediu = "Sediul social este obligatoriu";
        if (!data.cumparatorReprezentant.trim()) {
          errors.cumparatorReprezentant = "Reprezentantul legal este obligatoriu";
        } else if (data.cumparatorReprezentant.trim().split(/\s+/).length < 2) {
          errors.cumparatorReprezentant = "Introduceti numele complet (nume si prenume)";
        }
      } else {
        if (!data.cumparatorNume.trim()) {
          errors.cumparatorNume = "Numele este obligatoriu";
        } else if (data.cumparatorNume.trim().split(/\s+/).length < 2) {
          errors.cumparatorNume = "Introduceti numele complet (nume si prenume)";
        }
        if (data.cumparatorCNP.trim() && !/^\d{13}$/.test(data.cumparatorCNP.trim())) {
          errors.cumparatorCNP = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data.cumparatorCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.cumparatorCI.trim())) {
          errors.cumparatorCI = "Format invalid (ex: MZ 654321 sau MZ 6543210)";
        }
        if (!data.cumparatorAdresa.trim()) errors.cumparatorAdresa = "Adresa este obligatorie";
      }
    }

    if (stepId === "auto") {
      if (!data.marca.trim()) errors.marca = "Marca este obligatorie";
      if (!data.model.trim()) errors.model = "Modelul este obligatoriu";
      if (!data.anFabricatie) {
        errors.anFabricatie = "Anul fabricatiei este obligatoriu";
      } else if (Number(data.anFabricatie) < 1900 || Number(data.anFabricatie) > new Date().getFullYear() + 1) {
        errors.anFabricatie = "An invalid";
      }
      if (!data.serieSasiu.trim()) {
        errors.serieSasiu = "Seria de sasiu (VIN) este obligatorie";
      } else if (data.serieSasiu.trim().length !== 17) {
        errors.serieSasiu = "VIN-ul trebuie sa contina exact 17 caractere";
      }
      if (data.kmDeclaratie !== "necunoscut" && !data.kmRulati) {
        errors.kmRulati = "Kilometrajul este obligatoriu";
      }
    }

    if (stepId === "pret") {
      if (!data.pretVanzare) {
        errors.pretVanzare = "Pretul de vanzare este obligatoriu";
      } else if (Number(data.pretVanzare) <= 0) {
        errors.pretVanzare = "Pretul trebuie sa fie mai mare decat 0";
      }
      if (!data.dataVanzare) errors.dataVanzare = "Data vanzarii este obligatorie";
      if (data.modalitatePlata === "numerar") {
        if (data.valuta !== "RON") {
          errors.modalitatePlata = "Plata integrala in numerar nu este permisa pentru valuta straina";
        } else if (Number(data.pretVanzare) > 0) {
          const plafon = (data.vanzatorPJ || data.cumparatorPJ) ? 5000 : 10000;
          if (Number(data.pretVanzare) > plafon) {
            errors.modalitatePlata = `Plata integrala in numerar depaseste plafonul legal de ${plafon.toLocaleString("ro-RO")} RON`;
          }
        }
      }
      if (data.modalitatePlata === "numerar + transfer") {
        const plafon = (data.vanzatorPJ || data.cumparatorPJ) ? 5000 : 10000;
        const sumaNumerar = Number(data.sumaNumerar) || 0;
        if (!data.sumaNumerar) {
          errors.sumaNumerar = "Suma in numerar este obligatorie";
        } else if (sumaNumerar <= 0) {
          errors.sumaNumerar = "Suma trebuie sa fie mai mare decat 0";
        } else if (sumaNumerar > plafon) {
          errors.sumaNumerar = `Suma in numerar depaseste plafonul legal de ${plafon.toLocaleString("ro-RO")} RON`;
        } else if (data.valuta === "RON" && sumaNumerar >= Number(data.pretVanzare)) {
          errors.sumaNumerar = "Suma in numerar trebuie sa fie mai mica decat pretul total";
        }
      }
    }

    if (stepId === "conditii") {
      if (data.garantieActiva) {
        const areComponenta = data.garantieMotor || data.garantieCutie || data.garantieFranare || data.garantieAlte;
        if (!areComponenta) {
          errors.garantieComponente = "Selectati cel putin o componenta acoperita de garantie";
        }
        if (data.garantieAlte && !data.garantieAlteText.trim()) {
          errors.garantieAlteText = "Specificati componentele acoperite";
        }
      }
    }

    return errors;
  },
};

export default vanzareAutoConfig;
